import styled from 'styled-components';
import { Typography, FakeLink, Color } from '@figure/frontlib-gui';
import { useRedirect } from 'shared/hooks';

const Container = styled.div`
  margin-bottom: 32px;
  background-color: ${Color.GREY_3};
  padding: 16px;
`;

const HelocDecline = () => {
  const { redirectToDashboard } = useRedirect();
  const handleDashboardClick = () => redirectToDashboard();

  return (
    <Container>
      <Typography.H6>Figure Home Equity Line</Typography.H6>
      <Typography.Body>
        We’ve reviewed your pre-qualification request and are sorry that we can’t extend you a home equity line offer. You can review
        this decision in your adverse action notice, which will be added to your{' '}
        <FakeLink onClick={handleDashboardClick}>
          <Typography.Body>dashboard.</Typography.Body>
        </FakeLink>
      </Typography.Body>
    </Container>
  );
};

export default HelocDecline;
